import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { persistor, store } from "./app/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { LoadingBarContainer } from "react-top-loading-bar";

import { ThemeProvider } from "./ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider> {/* ✅ GLOBAL */}
          <LoadingBarContainer>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </LoadingBarContainer>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);